import { instance as axios, setJwtToken } from "../../config/axiosInstance";

// // ------------------------Get Content Detail------------------
// export const getContentApi = async (data) => {
//   const endPoint = `admin-cms/cms-detail?${new URLSearchParams({
//     ...data,
//   })}`;
//   return await axios.get(endPoint, setJwtToken());
// };

// //   Update Content Detail
export const updateContentApi = async (data) => {
  const endPoint = `/admin/cms`;
  return await axios.post(endPoint, data, setJwtToken());
};


// ------------Get-Content-list-Api-------------------
export const getContentApi = async (data) => {
  const endPoint = `/admin/cms?${new URLSearchParams(data).toString()}`;
  return await axios.get(endPoint, setJwtToken());
};